import { axios } from "utils";

import { ADMIN_SOILAI_URL as endpoint } from "consts";

import { Coordinates } from "models";

type TimeSpan = {
  startYear: number;
  endYear: number;
};

export const getSoilAIVisualisation = async (data: unknown) => axios.post(`${endpoint}/crop-visualisation`, { data });

export const getSoilAIFlyovers = async (data: unknown) => axios.post(`${endpoint}/flyovers`, { data });

export const getNdviScores = async (data: {
  fieldId: string;
  geometry: Coordinates[];
  center: Coordinates;
  timeSpan?: TimeSpan;
  cloudCover?: number;
}): Promise<
  {
    ndvi: {
      min: number;
      max: number;
      mean: number;
      stDev: number;
    };
    date: string;
  }[]
> => axios.post(`${endpoint}/ndvi-scores`, { data });
